/** Strings of the shared multi-select filter button. */
export const multiSelectEn = {
  multiSelect: {
    not: "Not: {{value}}",
    any: "Any: {{value}}",
  },
};
export const multiSelectCs: typeof multiSelectEn = {
  multiSelect: {
    not: "Ne: {{value}}",
    any: "Jakýkoli: {{value}}",
  },
};
